import { useState } from 'react';

export default function Accordion({ title, children }) {
    const [open, setOpen] = useState(false);

    const clickArrow = () => {
        setOpen(prev => !prev);
    }

    return (
        <div className='accordion border-t-[1px] hover:bg-primary-100 hover:bg-opacity-30'>
            <div 
                className='flex justify-between cursor-pointer px-[30px] py-[20px]'
                onClick={clickArrow}
            >
                <div className='text-heading2 font-semibold'>
                    {title}
                </div>

                <div>
                    <svg className={`transition-all ease-linear ${!open ? 'rotate-90' : '-rotate-90'}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 18L9 12L15 6" stroke="#393939" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>

            <div className={`${!open && 'hidden'} px-[30px] py-[20px] text-[20px]`}>
                {children}
            </div>
        </div>
    )
}